function hydrateActiveSlide(gallery, swiper) {
    const currentIndex = swiper.activeIndex;

    gallery.querySelectorAll('.swiper-slide').forEach((slide, index) => {
        if (index !== currentIndex) return;

        slide.querySelectorAll('.item-product-picture').forEach((img) => {
            const ds = img.getAttribute('data-src');
            if (!ds) return;
            img.setAttribute('src', ds);
            img.removeAttribute('data-src');
            img.setAttribute('is-loaded', '');

            const srcset = img.getAttribute('data-srcset');
            if (!srcset) return;
            img.setAttribute('srcset', srcset);
            img.removeAttribute('data-srcset');
        });

        slide.querySelectorAll('source').forEach((source) => {
            const ds = source.getAttribute('data-srcset');
            if (!ds) return;
            source.setAttribute('srcset', ds);
            source.removeAttribute('data-srcset');
            source.setAttribute('is-loaded', '');
        });
    });
}

function initItemSlider(gallery) {
    if (gallery.classList.contains('swiper-initialized')) return;

    const itemSlider = new Swiper(gallery, {
        loop: true,
        navigation: {
            nextEl: '.item-swiper-button.next',
            prevEl: '.item-swiper-button.prev',
        },
        pagination: {
            el: '.item-pagination',
            clickable: true,
        },
    });

    hydrateActiveSlide(gallery, itemSlider);

    // Lazy-load for each new slide
    itemSlider.on('slideChange', () => {
        hydrateActiveSlide(gallery, itemSlider);
    });
}

document.addEventListener("DOMContentLoaded", function () {
    /* itemSliders click events */
    document.addEventListener('click', async function (event) {
        const target = event.target;
        // Return if the target is not an Element
        if (!(target instanceof Element)) return;

        // Check if the clicked element is one of the allowed targets
        const arrayAllowedTargets = ['item-wishlist', 'item-add-cart-button'];
        if (!arrayAllowedTargets.some(className => target.classList.contains(className))) return;

        // Find the closest item-product ancestor
        const itemProduct = target.closest('.item-product') || target;
        if (!itemProduct) return; // No item-product found

        if (target.matches('.item-wishlist')) {
            // Wishlist button clicked
            const btnWishlist = itemProduct.querySelector('.item-wishlist');
            if (!btnWishlist) return;

            // Instead of checking an input, verify the data-itemsize attribute on the wishlist button
            const dataItemSize = btnWishlist.getAttribute('data-product-size') || '';

            if (dataItemSize !== '') {
                itemWishlist_withSize(target);
            }
        } else {
            const btnAddCart = itemProduct.querySelector('.item-add-cart-button');
            const form = btnAddCart.closest('form');
            const dataItemSize = btnAddCart.getAttribute('data-product-size') || '';
            if (itemProduct.hasAttribute('is-unique-size') && dataItemSize !== '') {
                const hasStock = await getAvailableQuantity(form);
                if (hasStock) {
                    addToBasket(form);
                }
            }
        }
    });

    /* ADD WISHLIST AND CART HANDLERS */
    function itemWishlist_withSize(target) {

        addToWishlist(target);
    }

    initializeItemSliders();
});

function initializeItemSliders() {
    const galleries = document.querySelectorAll('.item-visuals:not(.no-slider)');
    if (!galleries.length) return;

    // IntersectionObserver: init when in viewport
    const io = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;

                const gallery = entry.target;
                initItemSlider(gallery);

                // Stop observing once initialized
                observer.unobserve(gallery);
            });
        },
        {
            root: null,
            threshold: 0,              // triggers as soon as one pixel is visible
            rootMargin: '100px 0px',    // preload slightly before entering the viewport
        }
    );

    galleries.forEach((g) => io.observe(g));
}

function checkItemInWishlist(item) {
    const elem = item.querySelector('.item-wishlist') ? item.querySelector('.item-wishlist') : item.querySelector('.cart-item-to-wishlist');
    const itemId = elem.getAttribute('data-product-id');
    const sizeId = elem.getAttribute('data-product-size');
    const colorId = elem.getAttribute('data-product-color');

    fetch(`${path_relative_root}get_user_wishlist.php?product_id=${encodeURIComponent(itemId)}&size_id=${encodeURIComponent(sizeId)}&color_id=${encodeURIComponent(colorId)}`)
    .then(response => {
        if (!response.ok) throw new Error('Erreur réseau : ' + response.status);
        return response.json(); // si ton PHP renvoie du JSON
    })
    .then(userWishlist => {
        if (userWishlist.length) {
            elem.setAttribute('in-wishlist', '');
            return true;
        } else {
            return false;
        }
    })
    .catch(error => {
        console.error('Erreur AJAX :', error);
    });
}

function reloadItemSlider(itemId) {
    itemId.swiper.update();
}

function displayColorSelector(elem) {
    const colorSelector = elem.closest('form').querySelector('.item-colors');

    if (colorSelector) {
        colorSelector.setAttribute('is-displayed', '');
        toggleBackdrop(1);
        document.body.style.overflow = "hidden";

        document.querySelector('.modal-backdrop').addEventListener('click', function () {
            closeColorSelector();
            toggleBackdrop(0);
        });
    }
}

function closeColorSelector() {
    const colorSelector = document.querySelector('.item-colors[is-displayed]');

    if (colorSelector) {
        colorSelector.removeAttribute('is-displayed');
        toggleBackdrop(0);
        document.body.style.overflow = "";
    }
}

function displaySizeSelector(elem) {
    const sizeSelector = elem.closest('form').querySelector('.item-sizes');

    if (sizeSelector) {
        sizeSelector.setAttribute('is-displayed', '');
        toggleBackdrop(1);
        document.body.style.overflow = "hidden";

        document.querySelector('.modal-backdrop').addEventListener('click', function () {
            closeSizeSelector();
            toggleBackdrop(0);
        });
    }
}

function closeSizeSelector() {
    const sizeSelector = document.querySelector('.item-sizes[is-displayed]');

    if (sizeSelector) {
        sizeSelector.removeAttribute('is-displayed');

        // 👉 remove the class when closing
        document.querySelector('#buyTogetherSliderMobile')?.classList.remove('is-displayed-actif');

        const wrapper = document.querySelector('#buyTogetherSliderMobile > .swiper-wrapper');

        if (wrapper) {
            wrapper.style.marginLeft = '';
        }
            
        document.body.style.overflow = "";

        const lookModals = document.querySelector('.look-modal[modal-open]');
        if (lookModals) {
            return; // If any look modal is still open, do not toggle backdrop or body overflow
        }

        toggleBackdrop(0);
    }
}

document.addEventListener('click', function (event) {
    const target = event.target;

    if (target.classList.contains('item-color-more')) {
        if (target.closest('.item-colors').hasAttribute('is-deployed')) {
            target.closest('.item-colors').removeAttribute('is-deployed');
            return;
        }
        target.closest('.item-colors').setAttribute('is-deployed', '');
    }

    if (target.classList.contains('close-item-sizes')) {
        closeSizeSelector();
    }
});